export const OFFICERS = [
  { name: "Ahimbisibwe Alexandar", code: "AA001", signature: "/signatures/ahimbisibwe.png" },
  { name: "Nuabiine Nicholous", code: "NN002", signature: "/signatures/nuabiine.png" },
  { name: "Owayesu Ronald", code: "OR003", signature: "/signatures/owayesu.png" },
  { name: "Buttuura Isaiah", code: "BI004", signature: "/signatures/buttuura.png" },
];
